import { HttpClient } from "@angular/common/http";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { EmpresaData } from "src/app/shared/empresa-data.interface";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { API_BASE_URL_V } from "src/app/data-wp.service";

@Component({
  selector: "app-constancia-area-protegida",
  templateUrl: "./constancia-area-protegida.component.html",
  styleUrls: ["../../empresa-gestion-online.component.css"],
})
export class ConstanciaAreaProtegidaComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private spinner: NgxUiLoaderService
  ) { }

  @Output() closeModal = new EventEmitter();
  @ViewChild("modalRespuesta", { static: false }) modalRespuesta: ElementRef;
  datosEmpresa: EmpresaData;
  datosPlanDomicilio: any = null;
  modalMessage: string;

  ngOnInit() {
    this.datosEmpresa = JSON.parse(sessionStorage.getItem("data"));
    this.obtenerPlanDomicilio();
  }

  obtenerPlanDomicilio() {
    this.spinner.start();

    const body = {
      afiliado: this.datosEmpresa.empresa_codigo,
      dominio: this.datosEmpresa.empresa_dominio
    };

    this.http.post<any>(API_BASE_URL_V + "/empresa/obtener-plan-domicilio", body)
      .subscribe(
        (res) => {
          this.spinner.stop();
          if (res.success && res.data && res.data.resultado === 0) {
            this.datosPlanDomicilio = res.data;
          } else {
            console.error('Error al obtener plan y domicilio:', res.message || 'Error desconocido');
            this.datosPlanDomicilio = null;
          }
        },
        (error) => {
          this.spinner.stop();
          console.error('Error en la petición:', error);
          this.datosPlanDomicilio = null;
        }
      );
  }

  private async obtenerPlanDomicilioAsync(): Promise<void> {
    const body = {
      afiliado: this.datosEmpresa.empresa_codigo,
      dominio: this.datosEmpresa.empresa_dominio
    };

    try {
      const res = await this.http.post<any>(API_BASE_URL_V + "/empresa/obtener-plan-domicilio", body).toPromise();

      if (res.success && res.data && res.data.resultado === 0) {
        this.datosPlanDomicilio = res.data;
      } else {
        console.error('Error al obtener plan y domicilio:', res.message || 'Error desconocido');
        this.datosPlanDomicilio = null;
      }
    } catch (error) {
      console.error('Error en la petición:', error);
      this.datosPlanDomicilio = null;
    }
  }

  openModal(content) {
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      windowClass: "modal-socios-form",
    });
  }

  async onClick() {
    this.spinner.start();

    try {
      if (!this.datosPlanDomicilio) {
        await this.obtenerPlanDomicilioAsync();
      }

      if (!this.datosPlanDomicilio) {
        this.modalMessage = "No se pudieron obtener los datos del plan y domicilio. Por favor, intente nuevamente.";
        this.closeModal.emit();
        this.openModal(this.modalRespuesta);
        return;
      }

      // Generar la fecha actual en formato dd/mm/yyyy
      const fechaActual = new Date();
      const dia = fechaActual.getDate().toString().padStart(2, '0');
      const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
      const año = fechaActual.getFullYear();
      const fechaFormateada = `${dia}/${mes}/${año}`;

      // Crear el contenido HTML del documento con los datos de la empresa
      const contenidoHTML = this.generarContenidoHTML(fechaFormateada);

      // Crear y descargar el PDF
      await this.generarPDF(contenidoHTML);

      this.modalMessage = "Documento PDF generado y descargado exitosamente.";
    } catch (error) {
      console.error('Error en onClick:', error);
      this.modalMessage = "Error al generar el documento. Por favor, intente nuevamente.";
    } finally {
      this.spinner.stop();
      this.closeModal.emit();
      this.openModal(this.modalRespuesta);
    }
  }

  private generarContenidoHTML(fechaActual: string): string {
    let direccionCompleta = this.datosPlanDomicilio.direccion;

    return `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<title>vittal</title>
<link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,400i,700" rel="stylesheet" />

</head>

<body>
<table width="600" border="0" align="center" cellpadding="0" cellspacing="0">
  <tr>
    <td height="76"><img src="https://www.vittal.com.ar/mkt-mailings/autogestion/constanciaAP/header.jpg" width="600" height="76" alt="Facturación vittal" /></td>
  </tr>
</table>
<table width="600" border="0" align="center" cellpadding="0" cellspacing="0">
  <tr>
    <td height="130"><table width="580" border="0" align="center" cellpadding="0" cellspacing="10">
      <tr>
        <td height="30" align="center" valign="middle" style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 13px; color: #333; text-align:right; line-height:20px;">Buenos Aires, 05 de Marzo de 2024</td>
      </tr>
    </table>
      <table width="600" border="0" align="center" cellpadding="0" cellspacing="0">
      <tr>
        <td valign="middle" style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 13px; color: #333; text-align:left; line-height:20px;"><em>Ref.: Constancia de Afiliación</em><br /><br />
          Se deja constancia que el cliente <strong>${this.datosEmpresa.empresa_nombre || 'No especificado'}</strong> cuenta con el servicio de emergencias y urgencias médicas bajo el número de socio <strong>${this.datosEmpresa.empresa_codigo || 'No especificado'}</strong> en el domicilio sito en <strong>${direccionCompleta},</strong> desde el día <strong>${fechaActual}</strong> y hasta la fecha de emisión del presente documento.<br />
          La presente constancia tiene una validez de 30 días corridos a partir de la fecha de su emisión.<br /></td>
      </tr>
    </table>
      <table width="600" border="0" align="center" cellpadding="0" cellspacing="0">
        <tr>
          <td height="160" align="center" valign="bottom" style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 13px; color: #333; text-align:right; line-height:20px;"><table width="136" align="right">
            <tbody>
              <tr>
                <td><img src="https://www.vittal.com.ar/mkt-mailings/autogestion/constanciaAP/firma-mw.jpg" width="136" height="90" alt=""/></td>
              </tr>
              <tr>
                <td align="center"><strong>Mariela Waisbord</strong><br />
                  Presidente</td>
              </tr>
            </tbody>
          </table></td>
        </tr>
		  
      </table>
  
    <map name="Map" id="Map2">
      <area shape="rect" coords="395,97,523,117" href="https://api.whatsapp.com/send?phone=5491130326052" target="_blank" alt="Llamá a vittal" />
    </map>
    
    <table width="560" border="0" align="center" cellpadding="0" cellspacing="0"  style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 15px; color: #fff; text-align:center; line-height:20px; border-bottom:2px solid #FFF;">
      <tr>
        <td height="73
					" valign="middle"><img src="https://www.vittal.com.ar/mkt-mailings/autogestion/constanciaAP/flota-vittal.png" alt="flota vittal" width="600" height="140" usemap="#Map" border="0" />
          <map name="Map" id="Map">
            <area shape="rect" coords="397,97,521,117" href="https://api.whatsapp.com/send?phone=5491130324611" target="_blank" alt="Llamá a vittal" />
          </map></td>
      </tr>
      
    </table></td>
  </tr>
</table>
</body>
</html>

    `.trim();
  }

  private async generarPDF(contenidoHTML: string) {
    const element = document.createElement('div');
    element.innerHTML = contenidoHTML;
    element.style.position = 'absolute';
    element.style.left = '-9999px';
    element.style.top = '0';
    element.style.width = '600px'; // Mantener el ancho original del HTML
    element.style.height = 'auto';
    element.style.padding = '0';
    element.style.boxSizing = 'border-box';
    element.style.backgroundColor = 'white';
    document.body.appendChild(element);

    const fechaArchivo = new Date().toISOString().split('T')[0];
    const nombreEmpresa = this.datosEmpresa.empresa_nombre || 'Empresa';
    const nombreArchivo = `Constancia_Area_Protegida_${nombreEmpresa.replace(/[^a-zA-Z0-9]/g, '_')}_${fechaArchivo}.pdf`;

    try {
      const canvas = await html2canvas(element, {
        scale: 1,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        width: 600,
        height: element.scrollHeight
      });

      const pdf = new jsPDF('p', 'mm', 'a4');

      // Calcular las dimensiones para que quepa en A4
      const pageWidth = 210; // mm
      const pageHeight = 297; // mm
      const margin = 10; // mm
      const availableWidth = pageWidth - (2 * margin);
      const availableHeight = pageHeight - (2 * margin);

      // Calcular la escala para que quepa en la página
      const scaleX = availableWidth / canvas.width;
      const scaleY = availableHeight / canvas.height;
      const scale = Math.min(scaleX, scaleY, 1); // No escalar más allá del 100%

      const imgWidth = canvas.width * scale;
      const imgHeight = canvas.height * scale;

      // Centrar la imagen en la página
      const x = (pageWidth - imgWidth) / 2;
      const y = (pageHeight - imgHeight) / 2;

      pdf.addImage(canvas, 'PNG', x, y, imgWidth, imgHeight);
      pdf.save(nombreArchivo);
    } catch (error) {
      console.error('Error generando PDF con html2canvas:', error);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const texto = element.textContent || element.innerText || '';

      const lineas = texto.split('\n').filter(linea => linea.trim() !== '');

      let y = 20;
      pdf.setFontSize(12);

      lineas.forEach((linea, index) => {
        if (y > 280) {
          pdf.addPage();
          y = 20;
        }

        if (index === 0) {
          pdf.setFontSize(16);
          pdf.setFont('helvetica', 'bold');
        } else if (index === 1) {
          pdf.setFontSize(12);
          pdf.setFont('helvetica', 'normal');
        }

        pdf.text(linea.trim(), 20, y);
        y += 8;
      });

      pdf.save(nombreArchivo);
    }

    document.body.removeChild(element);
  }
} 